import { TRAVEL_SS_INSURANCE_FORM_SET_VALUE } from '../../../actions/travelSs/quote';
import { quoteFormValidation } from './quote';
import { TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE } from '../../../actions/travelSs/travelDetails';
import { travelDetailsValidation } from './travelDetails';
import { TRAVEL_SS_EMPLOYEE_DETAILS_FORM_SET_VALUE } from '../../../actions/travelSs/employeeDetails';
import { employeeDetailsValidation } from './employeeDetails';
import { TRAVEL_SS_NEXT_OF_KIN_FORM_SET_VALUE } from '../../../actions/travelSs/nextOfKin';
import { nextOfKinValidation } from './nextOfKin';
import { TRAVEL_SS_AGENT_MODAL_DETAILS_SET_VALUE } from '../../../actions/travelSs/agentModal';
import { agentModalFormValidation } from './travelAgentModal';
import { PAYMENTS_SET_VALUE } from '../../../actions/travelSs/payments';
import { paymentsFormValidation } from './payments';

export const travelSsInsuranceValidation = (store, next, action) => {
    if (action.type.startsWith(TRAVEL_SS_INSURANCE_FORM_SET_VALUE)) {
        return quoteFormValidation(store, next, action);
    }

    if (action.type.startsWith(TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE)) {
        return travelDetailsValidation(store, next, action);
    }

    if (action.type.startsWith(TRAVEL_SS_EMPLOYEE_DETAILS_FORM_SET_VALUE)) {
        return employeeDetailsValidation(store, next, action);
    }

    if (action.type.startsWith(TRAVEL_SS_NEXT_OF_KIN_FORM_SET_VALUE)) {
        return nextOfKinValidation(store, next, action);
    }

    if (action.type.startsWith(TRAVEL_SS_AGENT_MODAL_DETAILS_SET_VALUE)) {
        return agentModalFormValidation(store, next, action);
    }

    if (action.type.startsWith(PAYMENTS_SET_VALUE)) {
        return paymentsFormValidation(store, next, action);
    }

    return null;
};
